export const GET_CLIENT_DATA = 'GET_CLIENT_DATA';
export const GET_CLIENT_LOADING = 'GET_CLIENT_LOADING';
export const GET_SOCIAL_MEDIA_DATA = 'GET_SOCIAL_MEDIA_DATA';
export const GET_SOCIAL_MEDIA_LOADING = 'GET_SOCIAL_MEDIA_LOADING';
export const GET_PRIVACY_POLICY_DATA = 'GET_PRIVACY_POLICY_DATA';
export const GET_PRIVACY_POLICY_LOADING = 'GET_PRIVACY_POLICY_LOADING';
export const GET_TERMS_AND_CONDITION_DATA = 'GET_TERMS_AND_CONDITION_DATA';
export const GET_TERMS_AND_CONDITION_LOADING = 'GET_TERMS_AND_CONDITION_LOADING';
